// extracted by mini-css-extract-plugin
export var disabled = "pagination-control-module--disabled--WOMJm";
export var dots = "pagination-control-module--dots--WMJZE";
export var paginationArrow = "pagination-control-module--pagination-arrow--2c7Ai";
export var paginationContainer = "pagination-control-module--pagination-container--kW0oK";
export var paginationItem = "pagination-control-module--pagination-item--A6Lgk";
export var selected = "pagination-control-module--selected--PD74m";